import { Draggable, SelectBox, Switch } from 'devextreme-react'
import React, { memo, useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { Alert, Button, Col, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap'

import { Info } from 'react-feather'
import api from '../../../services/api-configuration'
import { getAllWarehouses } from '../../../services/apis'
import useFormatMessage from '../../../utils/useFormatMessage'

const InputCode = memo(({ title, id, children, type, field, disabled, value, onChange }) => {
    const { t } = useFormatMessage()

    return (
        <Col lg="12">
            <div className="dx-fieldset p-0 m-1">
                <div className="dx-field">
                    <div className="dx-field-label" style={{ color: "black" }}>{t(title)}</div>
                    <div className="dx-field-value d-flex">
                        {children || (
                            <Input
                                disabled={disabled}
                                id={id}
                                type={type || "text"}
                                value={value || ''}
                                onChange={(e) => onChange?.(field, e.target.value)}
                                min={type === "number" ? 0 : undefined}
                                placeholder={`${t('please')} ${t(title)} ${t('enter')} ...`}
                            />
                        )}
                    </div>
                </div>
            </div>
        </Col>
    )
})

const BolgeEkle = ({ selected, isOpen, setIsOpen, setTrigger, trigger }) => {
    let is_sanal = selected.zone_description ? (selected.zone_description)?.includes("SANAL") : null

    const { t } = useFormatMessage()
    const [formData, setFormData] = useState({
        warehouse_id: '',
        zone_code: '',
        zone_name: '',
        zone_description: '',
        capacity: '',
        zone_type: '',
        is_shipping_zone: false,
        requires_form_on_exit: false,
        is_active: true,
        domestic_area: true,
        antrepo: false
    })

    const notifyError = (message) => toast.error(message)
    const notifySuccess = (message) => toast.success(message)
    const [warehouses, setWarehouses] = useState([])

    useEffect(() => {
        const fetchData = async () => {
            if (isOpen) {
                try {
                    const res = await getAllWarehouses();
                    setWarehouses(res);
                } catch (err) {
                    notifyError(t("Depo Listesi Alınırken hata oluştu"));
                    console.error(err);
                }

                if (selected) {
                    setFormData({
                        warehouse_id: selected.warehouse_id || '',
                        zone_code: selected.zone_code || '',
                        zone_name: selected.zone_name || '',
                        zone_description: selected.zone_description || '',
                        capacity: selected.capacity || '',
                        zone_type: selected.zone_type || '',
                        is_shipping_zone: true,
                        requires_form_on_exit: selected.requires_form_on_exit || false,
                        is_active: selected.is_active !== undefined ? selected.is_active : true,
                        domestic_area: selected.domestic_area || false,
                        antrepo: selected.antrepo || false
                    });
                }
            }
        };

        fetchData();
    }, [isOpen, selected]);

    const handleInputChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }))
    }

    const validateForm = () => {
        if (!formData.zone_code) {
            notifyError(t("Bölge Kodu") + " " + t("Boş Olamaz"))
            return false
        }
        if (!formData.zone_name) {
            notifyError(t("Bölge Adı") + " " + t("Boş Olamaz"))
            return false
        }
        if (!formData.capacity) {
            notifyError(t("Kapasite") + " " + t("Boş Olamaz"))
            return false
        }
        if (!formData.zone_type) {
            notifyError(t("Tip") + " " + t("Boş Olamaz"))
            return false
        }
        return true
    }

    const handleSubmit = async () => {
        if (!validateForm()) {
            return
        }

        const submitData = {
            ...formData,
            capacity: parseInt(formData.capacity),
            warehouse_id: parseInt(formData.warehouse_id),
            create_user_id: parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii'))
        }

        if (selected?.id) {
            submitData.id = selected.id
            submitData.update_user_id = submitData.create_user_id
            delete submitData.create_user_id
        }

        try {
            await api.post(
                selected?.id ? '/zone/update' : '/zone/add',
                submitData
            )
            notifySuccess(t(`Bölge ${selected?.id ? "Güncelleme" : "Ekleme"} Başarılı`))
            setTrigger(!trigger)
            setIsOpen(false)
        } catch (err) {
            const errorMessage = err.response?.data?.error
            notifyError(t(`Bölge ${selected?.id ? "Güncelleme" : "Ekleme"} Başarısız`) + " : " + t(errorMessage))
            console.error(err)
        }
    }

    return (
        <Draggable handle='.modal-header'>
            <Modal size='lg' isOpen={isOpen} toggle={() => setIsOpen(!isOpen)}>
                <ModalHeader className='modal-header' toggle={() => setIsOpen(!isOpen)}>
                    {t("Bölge Ekle")}
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <InputCode
                            title="Depo Adı"
                            id="depo-kodu"
                            field="warehouse_id"
                            value={formData.warehouse_id}
                        >
                            <SelectBox
                                disabled={is_sanal}
                                className='w-100'
                                id="depo-kodu"
                                dataSource={warehouses}
                                displayExpr="warehouse_name"
                                valueExpr="id"
                                value={formData.warehouse_id}
                                onValueChanged={(e) => handleInputChange('warehouse_id', e.value)}
                            />
                        </InputCode>
                        <InputCode
                            title="Bölge Kodu"
                            id="bolge-kodu"
                            field="zone_code"
                            disabled={true}
                            value={formData.zone_code}
                            onChange={handleInputChange}
                        />
                        <InputCode
                            title="Bölge Adı"
                            id="bolge-adi"
                            field="zone_name"
                            disabled={is_sanal}
                            value={formData.zone_name}
                            onChange={handleInputChange}
                        />
                        <InputCode
                            title="Bölge Açıklaması"
                            id="bolge-des"
                            disabled={is_sanal}
                            field="zone_description"
                            value={formData.zone_description}
                            onChange={handleInputChange}
                        />
                        <InputCode
                            title="Kapasite"
                            id="kapasite"
                            type="number"
                            field="capacity"
                            value={formData.capacity}
                            onChange={handleInputChange}
                        />

                        <InputCode
                            title="Tip"
                            field="zone_type"
                            value={formData.zone_type}
                        >
                            <div className="w-full">
                                <SelectBox
                                    id="zone-type"
                                    disabled={is_sanal}
                                    dataSource={[
                                        { id: "TYPE_STOCK", name: "STOK" },
                                        { id: "TYPE_PDI", name: "PDI" },
                                        { id: "TYPE_PERON", name: "PERON" },
                                        { id: "TYPE_SHIPMENTAREA", name: "SEVK BÖLGESİ" },
                                        { id: "TYPE_DAMAGE", name: "HASARLI BÖLGE" },
                                        { id: "TYPE_OTHER", name: "DİĞER" }
                                    ]}
                                    displayExpr="name"
                                    valueExpr="id"
                                    value={formData.zone_type}
                                    onValueChanged={(e) => handleInputChange('zone_type', e.value)}
                                />
                                {formData.zone_type === 'TYPE_PERON' && (
                                    <Alert className="mt-2" variant="warning" color='warning'
                                        style={{ color: "#3d3d3d" }}
                                    >
                                        <Info className="h-4 w-4" />&nbsp;
                                        PERON bölgesi altına <strong>PP-999</strong> adresini eklemeyi unutmayınız.<br /> PP-999 adresi çoklu depo grupaj operasyonlarında ortak sevkiyat noktası olarak kullanılır.
                                        Depoda başka PERON bölgesi varsa, PP-999 adresini <strong>sadece birinde</strong> tanımlamanız yeterlidir.
                                    </Alert>
                                )}
                            </div>
                        </InputCode>

                        <InputCode title=" ">
                            <div className="w-90 d-flex justify-between items-end mt-1"
                                style={{ gap: "10px" }}
                            >
                                <div className="d-flex"
                                    style={{ gap: "10px" }}
                                >
                                    <Label className='m-0 mr-2'>Milli Alan</Label>
                                    <Switch
                                        width={"100px"}
                                        id="milli-alan"
                                        value={formData.domestic_area}
                                        disabled={is_sanal}
                                        onValueChanged={(e) => {
                                            handleInputChange('domestic_area', e.value)
                                            if (e.value) {
                                                handleInputChange('antrepo', false)
                                            }
                                        }}
                                        onText={t("Evet")}
                                        offText={t("Hayır")}
                                    />
                                </div>
                                <div className="d-flex items-end gap-4" style={{ gap: "10px" }}>
                                    <Label className='m-0 m-2'>Antrepo</Label>
                                    <Switch
                                        width={"100px"}
                                        id="antrepo"
                                        value={formData.antrepo}
                                        disabled={formData.domestic_area}
                                        onValueChanged={(e) => handleInputChange('antrepo', e.value)}
                                        onText={t("Evet")}
                                        offText={t("Hayır")}
                                    />
                                </div>
                            </div>
                        </InputCode>

                        {/* <InputCode title="Sevke Açık Bölge">
                            <Switch
                                width={"100px"}
                                value={formData.is_shipping_zone}
                                onValueChanged={(e) => handleInputChange('is_shipping_zone', e.value)}
                                onText={t("Evet")}
                                offText={t("Hayır")}
                            />
                        </InputCode> */}

                        <InputCode title="Bölgeden Çıkışta Form Yazdır">
                            <Switch
                                width={"100px"}
                                value={formData.requires_form_on_exit}
                                onValueChanged={(e) => handleInputChange('requires_form_on_exit', e.value)}
                                onText={t("Evet")}
                                offText={t("Hayır")}
                            />
                        </InputCode>

                        <InputCode title="Geçerli">
                            <Switch
                                width={"100px"}
                                value={formData.is_active}
                                onValueChanged={(e) => handleInputChange('is_active', e.value)}
                                onText={t("Evet")}
                                offText={t("Hayır")}
                            />
                        </InputCode>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button
                        id='save-button'
                        color="secondary"
                        onClick={handleSubmit}
                    >
                        {t("Kaydet")}
                    </Button>
                    <Button
                        id='cancel-button'
                        color="danger"
                        onClick={() => setIsOpen(false)}
                    >
                        {t("İptal")}
                    </Button>
                </ModalFooter>
            </Modal>
        </Draggable>
    )
}

export default BolgeEkle